import reducerRegistry from 'reduxUtils/reducerRegistry';

const reducerName = 'common_widgets';
const createActionName = name => `toi/${reducerName}/${name}`;

export const RECEIVE_COMMON_WIDGETS_DATA = createActionName(
  'RECEIVE_COMMON_WIDGETS_DATA',
);

export function receiveCommonWidgetsData(data) {
  return {
    type: RECEIVE_COMMON_WIDGETS_DATA,
    payload: [...data],
  };
}

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case RECEIVE_COMMON_WIDGETS_DATA: {
      return {
        ...state,
        data: action.payload,
      };
    }

    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
